/**
 * The cockpit frame's two counts (PRD-333, Figma 00a): admin's `GET /api/review/counts` through the generated
 * client, the open questions and the held entries beside their tabs. A read of two ledgers on the server, so
 * nothing here counts; a screen that files a question or a fix invalidates `countsKey` (declared here because the shell reads
 * it and the screens that change it may not import the shell).
 */
import { useQuery } from '@tanstack/react-query';
import { adminClient } from './admin';
import { dataOrThrow } from './typed';
import type { components } from './types/api';

export type NavCounts = components['schemas']['NavCounts'];

export const countsKey = ['review', 'counts'] as const;

/** The held tray's read (declared here for the same reason as `countsKey`: the walk's acts move the held entries too). */
export const heldKey = ['review', 'held'] as const;

/** The questions list's read (declared here for the same reason: an Ask back on the walk and a settled held entry move the questions too). */
export const questionsKey = ['review', 'questions'] as const;

/** The tabs' counts; absent until the read answers (a tab then wears none, never a zero it does not know). */
export function useNavCounts(): NavCounts | undefined {
  return useQuery<NavCounts>({
    queryKey: countsKey,
    queryFn: async () => {
      const response = await adminClient.GET('/api/review/counts');
      return dataOrThrow(response, 'the counts');
    },
  }).data;
}
